import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getTopPageApi = params =>
  axios.get(`${API_HOST}/v2/responsive/topPage`, {
    params,
    withCredentials: true
  });

export const getFirstLoginAfterReleaseShopData = () =>
  axios.get(`${API_HOST}/first-login-after-release`, {
    withCredentials: true
  });

export const putFirstLoginAfterReleaseShopData = params =>
  axios.put(`${API_HOST}/first-login-after-release`, params, {
    withCredentials: true
  });

export default getTopPageApi;
